import get from "lodash/get";

const getSectionSlug = (state, pageType) => {
  if (pageType === "story-page") {
    return get(state, ["data", "story", "sections", 0, "slug"], "");
  } else if (pageType === "section-page") {
    return get(state, ["data", "section", "slug"], "");
  }
  return "";
};

const getStoryId = (state, pageType, storyId) => {
  if (storyId) {
    return storyId;
  }

  if (pageType === "story-page") {
    return get(state, ["data", "story", "public-identifier"], get(state, ["data", "story", "id"], ""));
  }
  return "";
};

export const setViewportSizeMapping = (adSlot, viewPortSizeMapping) => {
  const mapping =
    viewPortSizeMapping.length === 1
      ? window.googletag.sizeMapping().addSize(viewPortSizeMapping[0].viewport, viewPortSizeMapping[0].sizes).build()
      : window.googletag
          .sizeMapping()
          .addSize(viewPortSizeMapping?.[0]?.viewport, viewPortSizeMapping?.[0]?.sizes)
          .addSize(viewPortSizeMapping?.[1]?.viewport, viewPortSizeMapping?.[1]?.sizes)
          .build();

  adSlot?.defineSizeMapping(mapping);
};

function refreshSlot(id) {
  window.googletag.cmd.push(function () {
    if (window.googletag.pubadsReady) {
      // detect whether PubAdsService is fully loaded
      const existingSlot = window.googletag
        .pubads()
        .getSlots()
        .filter((item) => id === item.getSlotElementId());

      window.googletag.pubads().refresh(existingSlot);
    }
  });
}

const getEnvironment = (qtState) => {
  return get(qtState, ["config", "ads-config", "environment"], "");
};

export const setTargetingParams = (adSlot, qtState, storySectionSlug, lazyLoadRefreshAdUnit = true, storyId) => {
  const pageType = get(qtState, ["pageType"], "");
  const environment = getEnvironment(qtState);
  const sectionSlug = storySectionSlug || getSectionSlug(qtState, pageType);
  const targetStoryId = getStoryId(qtState, pageType, storyId);

  adSlot
    .addService(window.googletag.pubads())
    .setTargeting("Page_Type", pageType)
    .setTargeting("environment", environment);

  if (sectionSlug) {
    adSlot.setTargeting("Section_Name", sectionSlug);
  }

  if (targetStoryId) {
    adSlot.setTargeting("Article_ID", targetStoryId);
  }

  if (lazyLoadRefreshAdUnit) {
    adSlot.setTargeting("refresh", "true");
  }
};

export const useDfpSlot = ({
  path,
  size,
  id,
  qtState,
  viewPortSizeMapping,
  storySectionSlug,
  storyId,
  refreshAdUnit,
  outOfPage,
  lazyLoadRefreshAdUnit,
}) => {
  let slot = null;

  if (refreshAdUnit && window.googletag && window.googletag.apiReady) {
    refreshSlot(id);
  }

  window?.googletag?.cmd?.push(function () {
    if (outOfPage) {
      slot = window.googletag.defineOutOfPageSlot(path, id);
    } else {
      slot = window.googletag.defineSlot(path, size, id);
    }

    if (slot) {
      setTargetingParams(slot, qtState, storySectionSlug, lazyLoadRefreshAdUnit, storyId);
      !outOfPage && setViewportSizeMapping(slot, viewPortSizeMapping);
    }
  });

  window?.googletag?.cmd?.push(function () {
    window.googletag.display(id);
  });

  return slot;
};

export const getAdSlots = ({
  path,
  size,
  id,
  qtState,
  type,
  viewPortSizeMapping,
  storySectionSlug,
  storyId,
  loadAdsSynchronously,
  delayPeriod,
  refreshAdUnit,
  outOfPage,
  lazyLoadRefreshAdUnit,
}) => {
  if (loadAdsSynchronously) {
    return useDfpSlot({
      path,
      size,
      id,
      qtState,
      type,
      viewPortSizeMapping,
      storySectionSlug,
      storyId,
      refreshAdUnit,
      outOfPage,
      lazyLoadRefreshAdUnit,
    });
  } else {
    const timeoutId = setTimeout(() => {
      useDfpSlot({
        path,
        size,
        id,
        qtState,
        type,
        viewPortSizeMapping,
        storySectionSlug,
        storyId,
        refreshAdUnit,
        outOfPage,
        lazyLoadRefreshAdUnit,
      });
    }, delayPeriod);

    return () => clearTimeout(timeoutId); // cancel if unmounted early
  }
};
